// Dto
import SeStoreDTO from "../dto/SeStoreDTO"

// Types
import { LocalePackConfig, PackConfigValue } from '@/config/pack-config'

// Helpers
import getPackConfigByLocale from '../../initScripts/getPackConfigByLocale'



const buildSearchEventPackageArr = (seStore: SeStoreDTO): string[] => {
    if(!seStore.packages || !Array.isArray(seStore.packages)) return []
    const configForLocale: LocalePackConfig = getPackConfigByLocale(window.locale)

    // Map of packCode and label
    const packCodeLabelMap: Map<string, string> = new Map()

    // Assign the values to the map
    configForLocale.forEach(
        (
            item: {
                label: string;
                values: PackConfigValue[];
            }
        ) =>  {
            const firstValue: PackConfigValue =  item.values[0]
            if(!firstValue || !firstValue.id) return
            packCodeLabelMap.set(firstValue.id, item.label)
        }
    )

    return seStore.packages.map((packCode: string) => packCodeLabelMap.get(packCode) || "")
}

export default buildSearchEventPackageArr